import EmailIcon from './EmailIcon';
export default EmailIcon;
